<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title">
                    <span v-t="'message.item_peer_to_peer_auto_end_time_setting'"></span>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="200px" class="dialog-form-item">
                        <el-form-item prop="methodType" ref="methodType" :class="{'error-message': validationError}">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_peer_to_peer_auto_end_time_setting'"></span>
                            </div>
                            <el-input id="p2pAutoEndTime" 
                                    class="input-item" 
                                    type="text" 
                                    :placeholder="$t('message.place_holder_input_text')" 
                                    v-model="p2pAutoEndTime"
                                    @input.native="handleInputChange()"
                                    @compositionstart.native="compositionStart"
                                    @compositionend.native="compositionEnd"
                                    clearable @clear="handleInputChange()" />
                            <div class="error-text" :style="validationError ? 'visibility: visible;' : 'visibility: hidden;'">{{ errorMessage }}</div>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from '../../../commonutil.js';
import commonValidate from '../../../common-validate.js';

const DURATION_LIMIT_MAX = 3600;
const DURATION_LIMIT_MIN = 1;
const VALIDATION_OK = false;
const VALIDATION_NG = true;

export default {
    props: {
        appData: {}
    },
    data() {
        return {
            p2pAutoEndTime: 0,
            disableButton: true,
            errorMessage: "",
            isComposing: false,
        };
    },
    methods: {
        saveChange: function() {
            this.$emit('save', this.p2pAutoEndTime);
        },
        handleInputChange: function() {
            this.disableButton = (this.p2pAutoEndTime == this.appData.p2pAutoEndTime);
            this.validateInput();
        },
        validateInput: function() {
            let validateResult = commonValidate.validateItem(this.$i18n, "numeric", this.p2pAutoEndTime);
            if (!validateResult.valid) {
                this.setValidationStatus(VALIDATION_NG, validateResult.message);
                return;
            }
            if (this.p2pAutoEndTime > DURATION_LIMIT_MAX) {
                this.setValidationStatus(VALIDATION_NG, commonUtil.getMessageText(this.$i18n,"error_validate_duration_higher_limit"));
                return;
            }
            if (this.p2pAutoEndTime < DURATION_LIMIT_MIN) {
                this.setValidationStatus(VALIDATION_NG, commonUtil.getMessageText(this.$i18n,"error_validate_duration_lower_limit"));
                return;
            }

            this.setValidationStatus(VALIDATION_OK, "");
        },
        compositionStart() {
          this.isComposing = true;
        },
        compositionEnd() {
            this.isComposing = false;
            this.validateInput();
        },
        setValidationStatus(validation, msg) {
            this.validationError = validation;
            this.disableButton = validation;
            this.errorMessage = msg;
        }
    },
    created: function() {
        this.p2pAutoEndTime = Number(this.appData.p2pAutoEndTime);
    }
}
</script scoped>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}

.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.error-text {
    color: red;
    height: 15px;
    margin-top: 1px;
    visibility: hidden; 
}

</style>
